import { render, staticRenderFns } from "./property-rates.vue?vue&type=template&id=06a63b9b&"
import script from "./property-rates.vue?vue&type=script&lang=js&"
export * from "./property-rates.vue?vue&type=script&lang=js&"
import style0 from "./property-rates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports